import { render, staticRenderFns } from "./Ammunition.vue?vue&type=template&id=3df788b9&"
import script from "./Ammunition.vue?vue&type=script&lang=ts&"
export * from "./Ammunition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports